<script>
import Pagination from '@/components/Pagination'
import {getUserAuctionList, onePriceAuctionOrder} from '@/api/xunyou'
export default {
  // 注册组件
  components: {Pagination},
  data () {
    return {
      loading:false,
      auctionList: [], // 拍卖列表
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      // 分页参数
      pageparm:{
        pageSize:10,
        currentPage:1,
        total:0,
      },
      // 请求数据参数
      formInline: {
        pageSize: 10,
        pageNum: 1,
        uid: JSON.parse(localStorage.getItem("userdata")).userId || {},
        status: 2,
      },
      interval: null, // 定时器
      endTime: '', // 结束时间
      isOrdering: false,
    }
  },
  mounted() {
    this.getAuction_list()
    this.interval = setInterval(() => {
      this.auctionList = this.auctionList.map(item => ({
        ...item,
        endTime: item.endTime
      }));
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getAuction_list()
    },
    // 当前用户可参与的拍卖列表接口
    getAuction_list(){
      this.loading =true
      getUserAuctionList(this.formInline)
        .then(res => {
          if (res.code === 0) {
            this.loading = false
            this.auctionList = res.rows;
            this.pageparm.currentPage = this.formInline.pageNum
            this.pageparm.pageSize = this.formInline.pageSize
            this.pageparm.total = res.total
          } else if(1 === parseInt(res.code)) {
            this.$router.push({path:'/login'})
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          console.log('getUserAuctionList fail', err)
          this.loading = false
          this.$message.error('查询拍卖失败，请稍后再试！')
        })
    },
    gotoDetail(item){
      this.$router.push({path:'/auctionDetail',query:{auctionId:item.id}})
    },
    goToOrderPage(item){
      this.isOrdering = true;
      onePriceAuctionOrder({
        auctionId: item.id,
        uid: this.userInfo.userId,
        price: 0
      }).then(res => {
        console.log(res)
        if(res.code === 0){
          this.$message.success("下单成功")
          setTimeout(() => {
            this.$router.push({path:'/auctionOrderDetail',query:{oid:res.data.oid}})
          }, 800)

        } else {
          this.$message.error(res.msg);
        }
      })
        .catch(err => {
          console.log('getAuctionDetail fail', err)
          this.loading = false
          this.$message.error('拍下失败，请稍后再试！')
        })
        .finally(() => {
          this.isOrdering = false; // 设置标志位为 false
        });
    },
    //   类型转换
    auctionType(type){
      switch(type) {
        case 1:
          return '明拍'
          break;
        case 2:
          return '暗拍'
          break;
        case 3:
          return '一口价'
          break
        default:
          return '--'
      }
    },
    //   B=零售,C=分销,D=拍卖,Z=待整理
    levelText(level){
      switch(level) {
        case 'B':
          return '零售'
          break;
        case 'C':
          return '分销'
          break;
        case 'D':
          return '拍卖'
          break;
        case 'Z':
          return '待整理'
          break;
        default:
          return '--'
      }
    },
    formatCountdown(startTime, endTime) {
      const now = new Date();
      const start = new Date(startTime);
      const end = new Date(endTime);
      const diff = end.getTime() - now.getTime();

      if (now.getTime() - start.getTime() < 0) {
        return { status: '未开始', countdown: '' };
      }
      if (diff <= 0) {
        return { status: '已结束', countdown: '' };
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      const countdown = days > 0 ? `${days}天 ${hours}小时 ${minutes}分钟 ${seconds}秒` : `${hours}小时 ${minutes}分钟 ${seconds}秒`;

      return { status: '进行中', countdown };
    },
  }
}
</script>

<template>
  <div class="right_a_side_content">
    <h3 class="headerTitle">拍卖列表</h3>
    <el-divider></el-divider>
    <el-row :gutter="20"  v-loading='loading'>
      <el-col v-for="item in auctionList" :key="item.id" >
        <div class="auction-item">
          <div class="auction-item-header">
            <div style="width: 60%">
              <p>{{item.title}}</p>
              <span>{{auctionType(item.type)}}</span><el-divider direction="vertical"></el-divider>
              <span>加价幅度：¥{{item.bidIncrement}}</span><el-divider direction="vertical"></el-divider>
<!--              <span>参与：{{item.bidderNumber || 0}}</span><el-divider direction="vertical"></el-divider>-->
              <span v-if="formatCountdown(item.startTime, item.endTime).status === '进行中'">距结束：{{ formatCountdown(item.startTime, item.endTime).countdown }}</span>
              <span v-else>{{formatCountdown(item.startTime, item.endTime).status}}</span>
              <p  v-if="item.platformRemark !== ''">
                <span style="font-size: 12px">平台备注：{{item.platformRemark}}</span>
              </p>
            </div>
            <div>
              <span class="auction-item-money">起拍价：<i>{{ (item.startingPrice || 0).toFixed(2)  }} 元</i></span>
            </div>
          </div>
          <el-row class="auction-item-info">
            <el-col :span="20" @click.native="gotoDetail(item)">
              <el-row class="order_goods"  v-for="(goodsItem,index) in item.bxyAuctionCommodityList" :key="index">
                <el-col :span="15" class="order_Info_item">
                  <p style="width: 166%">
                    {{goodsItem.name}}
                    <span style="color:#78b942">{{goodsItem.skuName!=null ?goodsItem.skuName:'默认规格'}}</span>
<!--                    <el-divider direction="vertical"></el-divider>-->
<!--                    <span>编码:{{goodsItem.skuNo}}</span>-->
                    <el-divider direction="vertical"></el-divider>
                    <span>等级:{{levelText(goodsItem.skuLevel)}}</span>
                    <el-divider direction="vertical"></el-divider>
                    <span style="padding-right: 4px">¥{{ (goodsItem.price || 0).toFixed(2) }}</span><span>x{{goodsItem.auctionNum || 1 }}</span>
                    <span> = {{ (goodsItem.price * goodsItem.auctionNum).toFixed(2) }}</span>
                  </p>

                </el-col>
              </el-row>
              <el-col>
                <el-button type="text" v-if="item.bxyAuctionCommoditySize > 3" @click="gotoDetail(item)">查看更多商品</el-button>
              </el-col>
            </el-col>
            <el-col :span="4">
              <el-button class="buttonStyle" @click="gotoDetail(item)">拍卖详情</el-button>
              <el-button class="buttonStyle dangerBg" :disabled="item.status !== 2 || formatCountdown(item.startTime, item.endTime).status !== '进行中' || isOrdering" @click="goToOrderPage(item)">立即拍下</el-button>
            </el-col>
          </el-row>
        </div>


      </el-col>
      <el-col class="noData"  v-if="auctionList.length === 0">
        <div>暂无拍卖活动</div>
      </el-col>
    </el-row>
    <el-col :span="24" class="pagination">
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </el-col>
  </div>
</template>

<style scoped lang="less">
  .noData{
    text-align: center;
    height: 200px;
    line-height: 200px;
  }
  .right_a_side_content {

    .headerTitle {
      font-size: 20px;
      height: 40px;
      line-height: 40px;
      color: #666;
    }
    i.pointNum {
      font-size: 42px;
      font-weight: 600;
    }

    .auction-item {
      padding: 10px;
      border: 1px solid #78b942 !important;
      margin-bottom: 10px;
      .auction-item-header {
        padding: 20px;
        box-sizing: border-box;
        border-bottom: 1px solid #ccc;
        display: flex;
        justify-content: space-between;
        p {
          font-size: 18px;
          color: #78b942;
          margin-bottom: 5px;
        }
        span {
          color: #333;
          font-size: 14px;
        }
        .auction-item-money i{
          font-size: 20px;
          color: #78b942;
        }
      }
      .auction-item-info {
        padding: 20px;
        box-sizing: border-box;
        .order_goods {
          margin-bottom: 20px;
          .order_Info_item {
            margin-left: 20px;
          }
        }
        button.el-button.buttonStyle {
          padding: 6px 30px;
          font-size: 12px;
          margin-bottom: 6px;
          margin-left: 0;
        }
        .dangerBg.buttonStyle{
          background-color:  #78b942;
          border-color:  #78b942;
          color: white;
        }
      }
    }

    .pagination{
      text-align: right;
      /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #78b942;
        color: #FFF;
        width: 20px;
      }
      /deep/.el-pagination.is-background .btn-next, /deep/.el-pagination.is-background .btn-prev, /deep/.el-pagination.is-background .el-pager li {
        width: 20px;
      }
      /deep/input[disabled], input[disabled="disabled"], input[readonly], input[readonly="readonly"] {
        background-color: transparent;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/auction/myAuction.vue